import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { BootstrapTable, SearchField, TableHeaderColumn } from 'react-bootstrap-table';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import notificationPopUp from '../../../../NotificationPopUp';

import commonFunctions from '../../../../commonFunctions';

import * as authenticationActions from '../../../../actions/authenticationActions';
import * as commonActions from '../../../../actions/commonActions';
import * as networkActions from '../../../../actions/networkActions';

import AddNetworkReferentModal from './AddNetworkReferentModal';
import ConfirmationModal from '../../../common/ConfirmationModal';
import TooltipFormatter from '../../../common/TooltipFormatter';

const createCustomSearchField = (props) => { return (<SearchField className='form-control' defaultValue='' placeholder='Filtra' />); };


class ReferentSection extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            authenticationState: this.props.authenticationState,
            commonState: this.props.commonState,
            networkReferents: [],
            addNetworkReferentModal: {
                networkReferent: {},
                show: false
            },
            deleteNetworkReferentModal: {
                networkReferentId: -1,
                show: false
            }
        };

        this.deleteNetworkReferent = this.deleteNetworkReferent.bind(this);
        this.loadReferentNetworks = this.loadReferentNetworks.bind(this);
        this.networkReferentConfirmDelete = this.networkReferentConfirmDelete.bind(this);
        this.networkReferentInsertButton = this.networkReferentInsertButton.bind(this);
        this.onNetworkReferentInModalChange = this.onNetworkReferentInModalChange.bind(this);
        this.onNetworkReferentGridOnRowClick = this.onNetworkReferentGridOnRowClick.bind(this);
        this.saveNetworkReferent = this.saveNetworkReferent.bind(this);
        this.showAddNetworkReferentModal = this.showAddNetworkReferentModal.bind(this);
        this.showDeleteNetworkReferentModal = this.showDeleteNetworkReferentModal.bind(this);
        this.tooltipFormatter = this.tooltipFormatter.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.commonState !== prevState.commonState)
            return Object.assign({}, prevState, { commonState: nextProps.commonState });
        return null;
    }

    componentDidMount() {
        this.loadReferentNetworks();
    }

    deleteNetworkReferent() {
        this.props.networkActions.deleteNetworkReferent(this.state.deleteNetworkReferentModal.networkReferentId).then(() => {
            notificationPopUp.success('Referenza Eliminata');
            this.showDeleteNetworkReferentModal();
            this.loadReferentNetworks();
        }).catch(error => {
            notificationPopUp.error(error);
        });
    }

    loadReferentNetworks() {
        this.props.networkActions.loadReferentNetworks(this.props.userId).then((networkReferents) => {
            this.setState(Object.assign({}, this.state, { networkReferents }));
        }).catch(error => {
            notificationPopUp.error(error);
        });
    }

    networkReferentConfirmDelete(next, dropRowKeys) {
        this.showDeleteNetworkReferentModal(dropRowKeys);
    }

    networkReferentInsertButton() {
        return (<button type="button" className="btn btn-info react-bs-table-add-btn" onClick={() => this.showAddNetworkReferentModal()}>
            <span><i className="glyphicon glyphicon-plus"></i>Aggiungi</span>
        </button>);
    }

    onNetworkReferentInModalChange(event) {
        const state = Object.assign({}, this.state);
        state.addNetworkReferentModal.networkReferent[event.target.name] = event.target.value;
        this.setState(state);
    }

    onNetworkReferentGridOnRowClick(row) {
        this.showAddNetworkReferentModal(row.id);
    }

    saveNetworkReferent() {

        if (_.toNumber(this.state.addNetworkReferentModal.networkReferent.networkId) < 1 || _.isNil(this.state.addNetworkReferentModal.networkReferent.startDate)) {
            notificationPopUp.warning('Attenzione compila i dati in modo coerente, Socio Sostenitore e Data inizio sono obbligatori.');
            return;
        }

        if (commonFunctions.dateDiffInDays(new Date(this.state.addNetworkReferentModal.networkReferent.startDate),
            new Date(this.state.addNetworkReferentModal.networkReferent.endDate)) < 1 && !_.isNil(this.state.addNetworkReferentModal.networkReferent.endDate)) {
            notificationPopUp.warning('Attenzione compila i dati in modo coerente, la data di inizio è maggiore di quella di fine');
            return;
        }

        this.props.networkActions.saveNetworkReferent(this.state.addNetworkReferentModal.networkReferent).then(() => {
            notificationPopUp.success('Referenza salvata.');
            this.showAddNetworkReferentModal();
            this.loadReferentNetworks();
        }).catch(error => {
            notificationPopUp.error(error);
        });
    }

    showAddNetworkReferentModal(networkReferentId) {
        var addNetworkReferentModal = {
            networkReferent: {},
            show: !this.state.addNetworkReferentModal.show
        };
        if (!_.isUndefined(networkReferentId) && _.isNumber(networkReferentId) > 0)
            addNetworkReferentModal.networkReferent = Object.assign({}, this.state.networkReferents.filter(x => x.id === networkReferentId)[0]);
        else
            addNetworkReferentModal.networkReferent.userId = this.props.userId;

        this.setState(Object.assign({}, this.state, { addNetworkReferentModal }));
    }

    showDeleteNetworkReferentModal(networkReferentArray) {
        const deleteNetworkReferentModal = Object.assign({}, this.state.deleteNetworkReferentModal);
        deleteNetworkReferentModal.show = !deleteNetworkReferentModal.show;

        if (!_.isNil(networkReferentArray) && !_.isNil(networkReferentArray.length))
            deleteNetworkReferentModal.networkReferentId = networkReferentArray[0];
        else
            deleteNetworkReferentModal.networkReferentId = -1;

        this.setState(Object.assign({}, this.state, { deleteNetworkReferentModal }));
    }

    tooltipFormatter(cell, row) {
        return (
            <TooltipFormatter text={cell} tooltip={cell} placement="top" />
        );
    }

    render() {
        const gridOptions = {
            deleteText: 'Elimina',
            exportCSVText: 'Esporta',
            handleConfirmDeleteRow: this.networkReferentConfirmDelete,
            insertBtn: this.networkReferentInsertButton,
            onRowClick: this.onNetworkReferentGridOnRowClick,
            searchField: createCustomSearchField,
            sizePerPageList: [5, 10, 20, 50]
        };

        return (
            <div>
                <label>Aree di riferimento</label>
                <BootstrapTable data={this.state.networkReferents} options={gridOptions} selectRow={{ mode: 'radio' }}
                    deleteRow insertRow search striped hover pagination exportCSV>
                    <TableHeaderColumn dataField='id' isKey hidden>Id</TableHeaderColumn>
                    <TableHeaderColumn width={'50%'} dataField='networkName' csvHeader='Socio Sostenitore' dataSort={true}>Socio Sostenitore</TableHeaderColumn>
                    <TableHeaderColumn width={'25%'} dataField='startDate' csvHeader='Data Inizio' dataSort={true} dataFormat={commonFunctions.dateToString}>Data Inizio</TableHeaderColumn>
                    <TableHeaderColumn width={'25%'} dataField='endDate' csvHeader='Data Fine' dataSort={true} dataFormat={commonFunctions.dateToString}>Data Fine</TableHeaderColumn>
                </BootstrapTable>
                <ConfirmationModal
                    title='Conferma Eliminazione Referenza'
                    message={'Confermi di volere ELIMINARE la Referenza ?'}
                    show={this.state.deleteNetworkReferentModal.show}
                    showHide={this.showDeleteNetworkReferentModal}
                    action={this.deleteNetworkReferent}
                    commonState={this.state.commonState}
                />
                <AddNetworkReferentModal
                    commonState={this.state.commonState}
                    onChange={this.onNetworkReferentInModalChange}
                    networkReferentInModalModel={this.state.addNetworkReferentModal}
                    networks={this.props.networks}
                    saveNetworkReferent={this.saveNetworkReferent}
                    toggle={this.showAddNetworkReferentModal}
                />
            </div>
        );
    }
}

ReferentSection.propTypes = {
    authenticationState: PropTypes.object.isRequired,
    commonState: PropTypes.object.isRequired,
    networks: PropTypes.array.isRequired,
    userId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        commonState: state.commonState,
        authenticationState: state.authenticationState
    };
}

function mapDispatchToProps(dispatch) {
    return {
        commonActions: bindActionCreators(commonActions, dispatch),
        authenticationActions: bindActionCreators(authenticationActions, dispatch),
        networkActions: bindActionCreators(networkActions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReferentSection);
